import { getStateStore } from '../../stores';
import { populateMicrophoneSelection } from '../managers/mediaManager';

const state = getStateStore('ipc');

export const initializeMicrophoneSelectionEvents = () => {
  populateMicrophoneSelection();
};
